import React from 'react';
import { IoMdCheckmark } from 'react-icons/io';
import PropTypes from 'prop-types';
import ImgHTML from '../ImgHTML';

const LandingPageInfoBox = ({
  icon,
  title,
  description,
  replaceIcon,
  version,
  smIcon
}) => {
  return (
    <div
      className={`col ${
        version === 'twoPerRow' ? 'col-md-5' : 'col-md-4'
      } p-3 p-md-3 justify-content-center`}
    >
      <div className="row">
        {replaceIcon ? (
          <div className="col-1 col-md-2 col-xl-1 mr-2">
            <div className="section-points">
              <div className="item">
                <div className="ok-icon ">
                  <IoMdCheckmark />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={`col-2 px-1 col-md-3 col-lg-2 ${smIcon && 'px-3'}`}>
            <ImgHTML
              className="work-with-icon"
              alt="Logo"
              title="Logo"
              src={icon}
            />
          </div>
        )}
        <div className="col p-2">
          <h3 className="font-weight-bold mb-2">{title}</h3>
          <div className="description">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageInfoBox;

LandingPageInfoBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
